import { render, staticRenderFns } from "./ThemeEditionPage.vue?vue&type=template&id=653611fd&"
import script from "./ThemeEditionPage.vue?vue&type=script&lang=ts&"
export * from "./ThemeEditionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports